module.exports = __webpack_public_path__ + "static/media/pattern.b88bd0ab.svg";